import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import Icon, { GLYPHS } from '../../../common/icon';

const SideBySideTimeTrackingIcon = ({ active }) => (
  <span>
    <Icon
      glyph={GLYPHS.stopwatch}
      size="small"
      className={classnames('u-ml--', active ? 'u-font-color-green' : 'u-font-color-red')}
    />
  </span>
);
SideBySideTimeTrackingIcon.propTypes = {
  active: PropTypes.bool,
};
SideBySideTimeTrackingIcon.defaultProps = {
  active: false,
};

export default SideBySideTimeTrackingIcon;
